/**
 * Created by Ning Jiang on 7/5/2019.
 */

export class BattleEvent {

    public static readonly COLLECT_PIXIE:string = "battleEvent_collectPixie";
    public static readonly COLLECT_PIRATE:string = "battleEvent_collectPirate";
    public static readonly CHECK_COLLECT:string = "battleEvent_checkCollect";
    public static readonly SET_PLAYER_SELECTION:string = "battleEvent_setPlaySelection";
    public static readonly PLAY_DEFEAT:string = "battleEvent_playDefeat";
    public static readonly UPDATE_XWAYS:string = "battleEvent_updateXways";
    public static readonly XWAYS_UPDATED:string = "battleEvent_XwaysUpdated";
}